export interface Conversation {
  id: string;
  title: string; // Auto-généré depuis le 1er message ou personnalisé
  createdAt: Date;
  updatedAt: Date;
  messages: Message[];
  assistantType: AssistantType;
  userId: string;
  isArchived?: boolean;
  isPinned?: boolean;
}

export interface Message {
  id: string;
  conversationId: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  /** Pièces jointes du message (JSON : fichiers déposés, cartes de l'agent Plans de fabrication). */
  attachments?: string | null;
  tokensUsed?: number;
}

export enum AssistantType {
  Engineer = 'engineer',
  DCE = 'dce',
  DocumentWriter = 'documentwriter',
  JuridiqueRH = 'juridiquerh',
  Ssi = 'ssi',
  PlansFabrication = 'plansfabrication'
}

export interface CreateConversationDto {
  assistantType: AssistantType;
  initialMessage?: string;
  title?: string;
}

export interface UpdateConversationDto {
  title?: string;
  isArchived?: boolean;
  isPinned?: boolean;
}

export interface AddMessageDto {
  role: 'user' | 'assistant';
  content: string;
  attachments?: string[];
  tokensUsed?: number;
}
